import React, { useState } from 'react';
import { CheckIcon, LinkIcon, LinkedinIcon, MessageCircleIcon } from 'lucide-react';
type ShareButtonsProps = {
  title: string;
  variant?: 'inline' | 'bar';
};
function XLogo({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-161" data-mp="3bdd1igaibgr1">
      <path d="M17.75 3h3.07l-6.7 7.66L22 21h-6.17l-4.83-6.32L5.47 21H2.4l7.17-8.2L2 3h6.33l4.37 5.78L17.75 3Zm-1.08 16.2h1.7L7.4 4.73H5.58L16.67 19.2Z" data-id="element-162" data-mp="36fbghptit7cx" />
    </svg>;
}
export function ShareButtons({
  title,
  variant = 'inline'
}: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const text = encodeURIComponent(title);
  const link = encodeURIComponent(url);
  const targets = [{
    label: 'Share on WhatsApp',
    href: `https://wa.me/?text=${text}%20${link}`,
    Icon: MessageCircleIcon
  }, {
    label: 'Share on LinkedIn',
    href: `https://www.linkedin.com/sharing/share-offsite/?url=${link}`,
    Icon: LinkedinIcon
  }, {
    label: 'Share on X',
    href: `https://x.com/intent/post?text=${text}&url=${link}`,
    Icon: XLogo
  }];
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      /* Clipboard unavailable: still confirm so the user can copy from the address bar. */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };
  const bar = variant === 'bar';
  const btn = bar ? 'flex h-11 flex-1 items-center justify-center rounded-[8px] text-ink transition-colors duration-150 ease-out active:bg-canvas-warm' : 'flex h-10 w-10 items-center justify-center rounded-full border border-canvas-line text-ink transition-colors duration-150 ease-out hover:border-ink/30 hover:bg-canvas-warm';
  return <div className={bar ? 'flex items-center gap-1' : 'flex items-center gap-2'} role="group" aria-label="Share this article" data-id="element-163" data-mp="3qrzr9e68n4aw">
      {bar && <span className="pl-2 pr-1 text-[13px] font-semibold text-ink" data-id="element-164" data-mp="3vr2vwxib38ic">Share</span>}
      {targets.map(({
      label,
      href,
      Icon
    }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className={btn} data-id="element-165" data-mp="21d8fae2lmbps">
          <Icon className="h-[18px] w-[18px]" data-id="element-166" data-mp="1rlb59anbtpsn" />
        </a>)}
      <button type="button" onClick={copy} aria-label={copied ? 'Link copied' : 'Copy link'} className={btn} data-id="element-167" data-mp="1rjhwnpt5kvi0">
        {copied ? <CheckIcon className="h-[18px] w-[18px] text-[#1B7A3D]" aria-hidden="true" data-id="element-168" data-mp="2ka9o69z9wvz0" /> : <LinkIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-169" data-mp="2k85mlyouk91w" />}
      </button>
      <span role="status" className="sr-only" data-id="element-170" data-mp="2fbor2jfbises">
        {copied ? 'Link copied to clipboard' : ''}
      </span>
      {copied && !bar && <span className="text-[13px] font-medium text-[#1B7A3D]" data-id="element-171" data-mp="2bbegetgkzdtl">Link copied</span>}
    </div>;
}